import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Button } from '../Button';

export const StyledButtonContent = styled(Button, {
  shouldForwardProp: (prop) =>
    !['isActive', 'showError'].includes(String(prop)),
})<{ isActive: boolean; showError?: boolean }>`
  width: auto;
  height: auto;
  border: 1px solid;
  padding: ${({ theme }) => `${theme.spacing(Spacing.Medium)}`};
  border-color: ${({ theme, isActive, showError }) => {
    if (showError && isActive) return theme.palette.red[600];
    if (isActive) return theme.palette.primary.main;
    return theme.palette.neutral[200];
  }};
  max-width: 258px;
  text-align: start;
`;
